<template>
  <div class="row">
    <div class="col">
      <card-container
              :title="$router.currentRoute.meta.title"
              :headers="tableHeaders"
              :lastPage="lastPage"
              :totalElements="totalElements"
              :currentPage="getCurrentPage()"
              :clickHandler="pagination">

        <template v-slot:card-header>

        </template>

        <template v-slot:card-header-search>
          <search v-model="lastPage" :listHandler="getList"/>
        </template>

        <template v-slot:table-rows>
          <tr v-for="item in items" :key="item.id">
            <td> {{ item.backendId }} </td>
            <td> {{ item.allocationWindow.captainId }} </td>
            <td> {{ item.city }} </td>
            <td> {{ $t(`${transPrefix}.lists.payment_type.${item.paymentType}`) }} </td>
            <td> {{ item.brand }} </td>
            <td> {{ $t(`${transPrefix}.lists.status.${item.status}`) }} </td>
            <td> {{ item.earnings }} </td>
            <td> {{ item.totalDistance }} </td>
            <td class="text-direction-ltr"> {{ item.createdAt | moment("Y-MM-DD hh:mm:ss A")  }} </td>
            <table-item-actions :actions="tableItemActions" :params="{'id':item.id}"/>
          </tr>
          <tr class="text-center" v-if="!items.length">
            <td colspan="999">{{ $t('messages.no_result_found')}}</td>
          </tr>
        </template>

        <template v-slot:card-footer>
          <export-action :crudCode="routePrefix" v-can:report="permissionPrefix"></export-action>
        </template>
      </card-container>
    </div>
  </div>
</template>
<script>

  import {  mapGetters } from "vuex";
  import { ORDERS_LIST as CRUD_ACTION_LIST} from 'actions/orders';
  import search from "./partials/search";
  const CRUD_CODE="orders";
  const CRUD_PERMISSION_CODE=`${CRUD_CODE}`;
  export default {
    name: "OrderIndex",
    components:{
      search,
    },
    data(){

      return {
        routePrefix: CRUD_CODE,
        transPrefix: CRUD_CODE,
        permissionPrefix: CRUD_PERMISSION_CODE,
        tableHeaders:[
          {
            'title':`${CRUD_CODE}.fields.backend_id`
          },
          {
            'title':`fields.captain_id`
          },
          {
            'title':`fields.city`
          },
          {
            'title':`${CRUD_CODE}.fields.payment_type`
          },
          {
            'title':`fields.brand_name`
          },
          {
            'title':`fields.status`
          },
          {
            'title':`${CRUD_CODE}.fields.earnings`
          },
          {
            'title':`${CRUD_CODE}.fields.km_total_distance`
          },
          {
            'title':`fields.created_at`
          },
          {
            'title':`fields.actions`
          }
        ],
        tableItemActions:[
          {
            code:'show',
            route_name:`${CRUD_CODE}.show`,
            can:`${CRUD_PERMISSION_CODE}_can_view`,
          },
        ],
        items: [],
        perPage:20,
        totalElements:0,
        lastPage:0,
      }
    },
    mounted() {
      this.getList();
    },
    computed:{
      ...mapGetters([
        "getSearchFilters","getSearchFiltersIfExists","getSearchFiltersSensitized"
      ])
    },
    methods: {
      getList(){
        this.$store.dispatch(CRUD_ACTION_LIST,{
          pageId: this.getCurrentPage()-1,
          ...this.getSearchFiltersSensitized
        }).then(response=>{
          this.items=response.data.data;
          this.perPage=response.data.perPage;
          this.totalElements=response.data.totalElements;
          this.lastPage=response.data.pageCount;
        });
      },
      pagination(page){
        if(page!== this.getCurrentPage()){
          this.$router.push({
            name: `${this.routePrefix}.index`,
            query:{
              page,
              ...this.getSearchFiltersIfExists
            }
          });
          this.getList();
        }
      },
      getCurrentPage(){
        let currentPage=this.$route.query.page??1;
        return parseInt(currentPage>=1?currentPage:1);
      },
    }
  };
</script>
